import { render, staticRenderFns } from "./SoftwareServerHeader.vue?vue&type=template&id=57d3e11a&scoped=true&"
import script from "./SoftwareServerHeader.vue?vue&type=script&lang=js&"
export * from "./SoftwareServerHeader.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareServerHeader.vue?vue&type=style&index=0&id=57d3e11a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3e11a",
  null
  
)

export default component.exports